import { CMSResource } from "app/resources/cmsresource";

export class HeaderBodyResource extends CMSResource {

	rid: number;	
	hasTwoCells: boolean;	
	cellOneActive: boolean;	
	cellTwoActive: boolean;	
	cellOneText: boolean;	
	cellTwoText: boolean;	
	cellOneImage: string;	
	cellTwoImage: string;
	cellOneImageString: string;
	cellTwoImageString: string;
	cellOneRo: string;	
	cellOneFr: string;	
	cellOneEn: string;
	cellOneDe: string;	
	cellTwoRo: string;	
	cellTwoFr: string;
	cellTwoEn: string;
	cellTwoDe: string;
}